const NAME = "EVALUATION_PROCESS_DEFINITION_ASSIGNMENT";

export default NAME;
